module.exports = __webpack_public_path__ + "static/homeHero-8a56d85b66fc741ce4455965c3ea5ca3.jpg";